import React from "react";
import CustomParagraph from "./CustomParagraph";
import { DownOutlined } from "@ant-design/icons";
import useAi from "../assets/images/useAi.svg";
import CustomButton from "./CustomButton";
import { Flex, Dropdown, Button, Image } from "antd";
import phoneAi from "../../src/assets/images/Aiphone.svg";
import expand_more from "../assets/images/expand_more.svg";
import UseAi from "../assets/images/UseAi";
import ExpandMore from "../assets/images/ExpandMore";
import { marked } from 'marked';

function StatusCardNotification({
  showButtons = true,
  cardStyle,
  icon,
  createdAt,
  title,
  description,
  bgColor,
  color,
  actionButtonText,
  actionButtonWidth,
  actionButtonBorderRadius,
  actionButtonBgColor,
  actionButtonOnClick,
  dismissAction,
  aiOptions = [],
  aiStatus,
  useAiButton,
  isCritical,
}) {
  const isAiInProgress =
    aiStatus === "ai_call_in_progress" || aiStatus === "ai_email_in_progress";

  const processedDescription = description ? description.replace(/\\n/g, '\n') : '';

  const aiDropdownItems = aiOptions.map((item) => ({
    key: item.key,
    disabled: item.disabled,
    label: (
      <Flex align="center" gap={8}>
        <div style={{ opacity: item.disabled ? 0.4 : 1, color: "black" }}>
          {item.icon}
        </div>
        <span
          style={{
            fontSize: "12px",
            fontWeight: 400,
            color: item.disabled ? "#BFBFBF" : "#000",
          }}
        >
          {item.label}
        </span>
      </Flex>
    ),
  }));

  const CardContent = (
    <Flex
      align="center"
      justify="space-between"
      gap={cardStyle === "style-2" ? 8 : 16}
      vertical={cardStyle === "style-2"}
      style={{
        padding: "16px",
        background: isAiInProgress
          ? "linear-gradient(0deg, #ffffff 0%, #f2faff 100%)"
          : bgColor,
        borderRadius: isAiInProgress ? "9px" : "12px",
      }}
    >
      <Flex gap={16} align="center" style={{ width: "100%" }}>
        {isAiInProgress ? (
          <img
            src={phoneAi}
            alt="AI call preview"
            preview={false}
            style={{
              width: "24px",
              height: "24px",
              objectFit: "contain",
              flexShrink: 0,
              display: "block",
            }}
          />
        ) : (
          icon
        )}

        <div>
          <CustomParagraph
            text={title}
            fontSize={12}
            fontWeight={600}
            lineHeight="20px"
            color={isAiInProgress ? "black" : color}
            marginBottom="4px"
          />
          <CustomParagraph
            htmlString={processedDescription ? marked(processedDescription, { breaks: true }) : ''}
            fontSize={12}
            fontWeight={400}
            lineHeight="20px"
            color={isAiInProgress ? "black" : color}
            marginBottom="0"
          />
          <CustomParagraph
            text={createdAt}
            fontSize={12}
            fontWeight={400}
            lineHeight="20px"
            color={isAiInProgress ? "black" : color}
            marginBottom="0"
          />
        </div>
      </Flex>

      {!isAiInProgress && (
        <>
          {showButtons === true && cardStyle === "style-1" && (
            <CustomButton
              text={actionButtonText}
              width="auto"
              padding="5px 15px"
              height="36px"
              color={color}
              bgColor={actionButtonBgColor}
              borderRadius={actionButtonBorderRadius}
              marginBottom="0"
              boxShadow="none"
              onClick={actionButtonOnClick}
            />
          )}

          {cardStyle === "style-2" && (
            <Flex gap={8} justify="flex-end" style={{ width: "100%" }}>
              <CustomButton
                text="Dismiss"
                width="auto"
                padding="5px 15px"
                fontSize={"12px"}
                fontWeight={"600"}
                height={36}
                color={color}
                bgColor={"initial"}
                boxShadow={"none"}
                onClick={dismissAction}
              />

              <CustomButton
                text={actionButtonText}
                width="auto"
                fontSize={"12px"}
                fontWeight={"600"}
                padding="5px 15px"
                height="36px"
                color={color}
                bgColor={actionButtonBgColor}
                borderRadius={actionButtonBorderRadius}
                marginBottom="0"
                boxShadow="none"
                onClick={actionButtonOnClick}
              />

              {aiOptions?.length > 0 && useAiButton && (
                <Dropdown
                  className="useAiDropdown"
                  menu={{
                    items: aiDropdownItems,
                    onClick: ({ key }) => {
                      const selectedItem = aiOptions.find(
                        (item) => item.key === key
                      );
                      if (selectedItem && !selectedItem.disabled) {
                        selectedItem.onClick();
                      }
                    },
                  }}
                  placement="bottomRight"
                >
                  <Button
                    style={{
                      height: "36px",
                      backgroundColor: !isCritical
                        ? "#FBE5B6"
                        : "rgb(187 3 42)",
                      borderRadius: "8px",
                      fontSize: "12px",
                      fontWeight: 600,
                      padding: "0 12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      border: "none",
                      boxShadow: "none",
                      outline: "none",
                    }}
                  >
                    <UseAi color={isCritical === false ? "#000" : "#fff"} />
                    <span
                      className={isCritical ? "white" : "black"}
                      style={{
                        fontSize: "12px",
                        fontWeight: 600,
                      }}
                    >
                      Use AI
                    </span>
                    <ExpandMore
                      color={isCritical === false ? "#000" : "#fff"}
                    />
                  </Button>
                </Dropdown>
              )}
            </Flex>
          )}
        </>
      )}
    </Flex>
  );

  return isAiInProgress ? (
    <div
      style={{
        background: "linear-gradient(90deg, #065DFF, #1C82D1, #42C47F)",
        padding: "3px",
        borderRadius: "12px",
        width: "100%",
      }}
    >
      {CardContent}
    </div>
  ) : (
    CardContent
  );
}

export default StatusCardNotification;
